import { createSelector } from 'reselect'
import configurationDataSelector from './configurationDataSelector'

const configurationIsBuildableSelector = createSelector(
    configurationDataSelector,
    (configurationData): boolean => configurationData.configurationState === 'BUILDABLE',
)

export default configurationIsBuildableSelector
